<template>
	<div>
		<case-form :schema="schema" class="mt6" />
		<case-form :schema="schemaOther" class="mt6" />
		<div class="xs-12 fs4 fw7 mb2 mt6">如果是，请提供详情</div>
		<j-accordion
			v-for="i in 3"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">替代居住地址</span>
				{{ i }}
			</div>
			<div slot="body" class="pr6 pl6 pt6 pb2 bg5">
				<case-form
					:schema="schemaAlternateResidenceAddress(i)"
					:isBoxed="false"
				/>
			</div>
		</j-accordion>
		<case-form :schema="schemaHasProperty" class="mt6" />
		<div class="fs4 fw7 lh125 mt6 mb2">
			如果是，请提供详情
		</div>
		<j-accordion
			v-for="i in numOfPropertyFields"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">物业详情</span>
				{{ i }}
			</div>
			<div slot="body" class="pr6 pl6 pt6 pb2 bg5">
				<case-form :schema="schemaPropertyList(i)" :isBoxed="false" />
			</div>
		</j-accordion>
		<case-form :schema="schemasHasRightOfAbode" class="mt6" />
		<div class="fs4 fw7 lh125 mt6 mb2">
			如果是，请提供详情
		</div>
		<j-accordion
			v-for="i in numOfResidencyFields"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">居住状态</span>
				{{ i }}
			</div>
			<div slot="body" class="pr6 pl6 pt6 pb2 bg5">
				<case-form :schema="schemaRightOfAbodeList(i)" :isBoxed="false" />
			</div>
		</j-accordion>
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
import JAccordion from "@/components/JAccordion/"

export default {
	components: {
		CaseForm,
		JAccordion
	},

	data() {
		return {
			numOfPropertyFields: 3,
			numOfResidencyFields: 3
		}
	},

	computed: {
		schema() {
			return [
				{
					label: "受保人",
					component: "entitySelect",
					bindTo: "case.insureds[0]",
					entity: "case.insureds[0]",
					props: {
						allowedEntityTypes: ["individual"]
					}
				},
				{
					label: "称谓",
					component: "entityField",
					entity: "case.insureds[0]",
					fieldToUpdate: "salutation",
					props: {
						updateOptions: {
							component: "select",
							props: {
								options: [
									{
										name: "Mr",
										value: "Mr"
									},
									{
										name: "Mrs",
										value: "Mrs"
									},
									{
										name: "Miss",
										value: "Miss"
									},
									{
										name: "Other",
										value: "Other"
									}
								]
							}
						}
					}
				},
				{
					label: "其他称谓",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0otherTitlesCN`,
					props: {
						suggest: {
							typeIncludes: `otherTitlesCN`
						},
						createOptions: {
							type: `otherTitlesCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "后缀名",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0suffixCN`,
					props: {
						suggest: {
							typeIncludes: `suffixCN`
						},
						createOptions: {
							type: `suffixCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "请问是否有曾用名，婚前姓氏或别名?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasFormerNameOrAliasCN`,
					props: {
						suggest: {
							typeIncludes: `hasFormerNameOrAliasCN`
						},
						createOptions: {
							type: `hasFormerNameOrAliasCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "如果答“是”，请在下方写出该姓名",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0formerNameOrAliasCN`,
					props: {
						suggest: {
							typeIncludes: `formerNameOrAliasCN`
						},
						createOptions: {
							type: `formerNameOrAliasCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "出生日期",
					component: "entityField",
					entity: "case.insureds[0]",
					fieldToUpdate: "dateOfBirth",
					props: {
						updateOptions: {
							component: "date"
						}
					}
				},
				{
					label: "出生城市",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0cityOfBirthCN`,
					props: {
						suggest: {
							typeIncludes: `cityOfBirthCN`
						},
						createOptions: {
							type: `cityOfBirthCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "出生国家",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0countryOfBirthCN`,
					props: {
						suggest: {
							typeIncludes: `countryOfBirthCN`
						},
						createOptions: {
							type: `countryOfBirthCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "国籍所在国",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0countriesOfCitizenshipCN`,
					props: {
						suggest: {
							typeIncludes: `countriesOfCitizenshipCN`
						},
						createOptions: {
							type: `countriesOfCitizenshipCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "地址",
					component: "entityAddress",
					entity: "case.holder",
					relation: "case.insureds[0].addresses",
					bindTo: "case.facts.insured0permanentReisdentAddressCN",
					props: {
						suggest: {
							typeIncludes: "permanentReisdentAddressCN"
						},
						createOptions: {
							type: "permanentReisdentAddressCN"
						}
					}
				},
				{
					label: "邮寄地址（如果与上述地址不同）",
					component: "entityAddress",
					entity: "case.holder",
					relation: "case.insureds[0].addresses",
					bindTo: "case.facts.insured0mailingAddressCN",
					props: {
						suggest: {
							typeIncludes: "mailingAddressCN"
						},
						createOptions: {
							type: "mailingAddressCN"
						}
					}
				},
				{
					label: "您在当前地址居住几年？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0durationAtPresentAddressCN`,
					props: {
						suggest: {
							typeIncludes: `durationAtPresentAddressCN`
						},
						createOptions: {
							type: `durationAtPresentAddressCN`,
							dataType: "number"
						}
					}
				},
				{
					label: "如果少于10年，您是否曾在别的国家居住过？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasLivedInOtherCountriesCN`,
					props: {
						suggest: {
							typeIncludes: `hasLivedInOtherCountriesCN`
						},
						createOptions: {
							type: `hasLivedInOtherCountriesCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "如 “是”，请写出您之前居住过的国家：",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0previousCountryOfResidenceCN`,
					props: {
						suggest: {
							typeIncludes: `previousCountryOfResidenceCN`
						},
						createOptions: {
							type: `previousCountryOfResidenceCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "电话号码",
					component: "entityContact",
					entity: "case.holder",
					relation: "case.insureds[0].contacts",
					bindTo: "case.facts.insured0homeNumberCN",
					props: {
						suggest: {
							typeIncludes: `homeNumberCN`
						},
						createOptions: {
							type: `homeNumberCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "营业号码",
					component: "entityContact",
					entity: "case.holder",
					relation: "case.insureds[0].contacts",
					bindTo: "case.facts.insured0businessNumberCN",
					props: {
						suggest: {
							typeIncludes: `businessNumberCN`
						},
						createOptions: {
							type: `businessNumberCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "传真号码",
					component: "entityContact",
					entity: "case.holder",
					relation: "case.insureds[0].contactsCN",
					bindTo: "case.facts.insured0faxNumberCN",
					props: {
						suggest: {
							typeIncludes: `faxNumberCN`
						},
						createOptions: {
							type: `faxNumberCN`,
							dataType: "string"
						}
					}
				}
			]
		},
		schemaOther() {
			return [
				{
					label: "您是否拥有超过一个居所？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasMoreThanOneResidenceCN`,
					props: {
						suggest: {
							typeIncludes: `hasMoreThanOneResidenceCN`
						},
						createOptions: {
							type: `hasMoreThanOneResidenceCN`,
							dataType: "boolean"
						}
					}
				}
			]
		},
		schemaHasProperty() {
			return [
				{
					label:
						"您是否有其他居住物业（度假屋，其他居住物业，分时共用房产等）?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasAdditionalResidentialPropertiesCN`,
					props: {
						suggest: {
							typeIncludes: `hasAdditionalResidentialPropertiesCN`
						},
						createOptions: {
							type: `hasAdditionalResidentialPropertiesCN`,
							dataType: "boolean"
						}
					}
				}
			]
		},
		schemasHasRightOfAbode() {
			return [
				{
					label:
						"除以上列出的国家之外，您是否拥有其他国家发行的有效护照，签证或永久居留身份?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasRightOfAbodeCN`,
					props: {
						suggest: {
							typeIncludes: `hasRightOfAbodeCN`
						},
						createOptions: {
							type: `hasRightOfAbodeCN`,
							dataType: "boolean"
						}
					}
				}
			]
		}
	},

	methods: {
		schemaAlternateResidenceAddress(i) {
			return [
				{
					label: "其他居所地址",
					component: "entityAddress",
					entity: "case.holder",
					relation: "case.insureds[0].addresses",
					bindTo: `case.facts.insured0alternateResidenceAddress${i}CN`,
					props: {
						suggest: {
							typeIncludes: `alternateResidenceAddress${i}CN`
						},
						createOptions: {
							type: `alternateResidenceAddress${i}CN`
						}
					}
				},
				{
					label: `曾居住多久月／年`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0alternateResidenceTimeSpent${i}CN`,
					props: {
						suggest: {
							typeIncludes: `alternateResidenceTimeSpent${i}CN`
						},
						createOptions: {
							type: `alternateResidenceTimeSpent${i}CN`,
							dataType: "string"
						}
					}
				}
			]
		},
		schemaPropertyList(i) {
			return [
				{
					label: `物业用途`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0residentialPropertyPurpose${i}CN`,
					props: {
						suggest: {
							typeIncludes: `residentialPropertyPurpose${i}CN`
						},
						createOptions: {
							type: `residentialPropertyPurpose${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: "完整地址",
					component: "entityAddress",
					entity: "case.holder",
					relation: "case.insureds[0].addresses",
					bindTo: `case.facts.insured0residentialPropertyAddress${i}CN`,
					props: {
						suggest: {
							typeIncludes: `residentialPropertyAddress${i}CN`
						},
						createOptions: {
							type: `residentialPropertyAddress${i}CN`
						}
					}
				},
				{
					label: `每年在该地址居留的时间`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0residentialPropertyTimeSpent${i}CN`,
					props: {
						suggest: {
							typeIncludes: `residentialPropertyTimeSpent${i}CN`
						},
						createOptions: {
							type: `residentialPropertyTimeSpent${i}CN`,
							dataType: "string"
						}
					}
				}
			]
		},
		schemaRightOfAbodeList(i) {
			return [
				{
					label: `国家`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0rightOfAbodeCountry${i}CN`,
					props: {
						suggest: {
							typeIncludes: `rightOfAbodeCountry${i}CN`
						},
						createOptions: {
							type: `rightOfAbodeCountry${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `护照，签证或永久居留身份`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0rightOfAbodeDocumentStatus${i}CN`,
					props: {
						suggest: {
							typeIncludes: `rightOfAbodeDocumentStatus${i}CN`
						},
						createOptions: {
							type: `rightOfAbodeDocumentStatus${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `每年居留时间`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0rightOfAbodeTimeSpent${i}CN`,
					props: {
						suggest: {
							typeIncludes: `rightOfAbodeTimeSpent${i}CN`
						},
						createOptions: {
							type: `rightOfAbodeTimeSpent${i}CN`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
